import { render, staticRenderFns } from "./UsersManagement.vue?vue&type=template&id=ab4b0b28&scoped=true&"
import script from "./UsersManagement.vue?vue&type=script&lang=js&"
export * from "./UsersManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4b0b28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ab4b0b28', component.options)
    } else {
      api.reload('ab4b0b28', component.options)
    }
    module.hot.accept("./UsersManagement.vue?vue&type=template&id=ab4b0b28&scoped=true&", function () {
      api.rerender('ab4b0b28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/SystemManagement/users-management/UsersManagement.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/SystemManagement/users-management/UsersManagement.vue
// module id = Y+h+
// module chunks = 0